import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "@/pages/Index";
import Athletes from "@/pages/Athletes";
import Judge from "@/pages/Judge";
import AthleteConsult from "@/pages/AthleteConsult";
import Ranking from "@/pages/Ranking";
import Admin from "@/pages/Admin";
import Debug from "@/pages/Debug";
import RoutePerformance from "@/pages/RoutePerformance";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/atletas" element={<Athletes />} />
        <Route path="/juiz" element={<Judge />} />
        <Route path="/consulta" element={<AthleteConsult />} />
        <Route path="/ranking" element={<Ranking />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/debug" element={<Debug />} />
        <Route path="/route-performance" element={<RoutePerformance />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
